import {
  WSDivider,
  WSElement,
  WSFlexBox,
  WSForm,
  WSPanel,
  WSPill,
  WSSelect,
  WSText
} from "@wingspanhq/fe-component-library";
import {
  IPayeeTaxFormResponse,
  IPayerTaxFormResponse
} from "@wingspanhq/payments/dist/interfaces/api/taxForm";

import { TaxFormViewer } from "../../../TaxDocuments/types";
import { CorrectedValuePreview } from "../CorrectedValuePreview";
import { OriginalValuePreview } from "../OriginalValuePreview";
import { CORRECTION_ADDRESS } from "../../constants/corrections";
import { FormPartialAddress } from "../../../Onboarding/components/FormPartialAddress";
import { IAddress } from "@wingspanhq/users/dist/lib/interfaces";
import { COUNTRY_OPTIONS } from "../../../../constants/user";

export interface AddressCorrectionFormProps {
  taxForm: IPayerTaxFormResponse | IPayeeTaxFormResponse;
  taxFormViewer?: TaxFormViewer;
  originalAddress: IAddress;
  showRequestedValue?: boolean;
  correctedAddress?: IAddress;
  isOverride?: boolean;
}

export const AddressCorrectionForm: React.FC<AddressCorrectionFormProps> = ({
  taxForm,
  taxFormViewer = TaxFormViewer.Payee,
  originalAddress,
  showRequestedValue,
  correctedAddress,
  isOverride
}) => {
  return (
    <WSPanel>
      <WSText.Paragraph mb="M" weight="medium">
        Address correction
      </WSText.Paragraph>

      <OriginalValuePreview
        mb="XL"
        taxForm={taxForm}
        correctionType={CORRECTION_ADDRESS}
      />

      <WSText.ParagraphSm mb="XL" color="gray500">
        {taxFormViewer === TaxFormViewer.Payee
          ? "The address has changed or is not accurate."
          : "The recipient's address is not accurate."}
      </WSText.ParagraphSm>

      <WSDivider my="XL" />

      {showRequestedValue ? (
        <WSElement mb="XL">
          <CorrectedValuePreview
            correctionType={CORRECTION_ADDRESS}
            taxForm={taxForm}
            taxFormViewer={taxFormViewer}
            correctionData={{
              addressCorrectionData: {
                address: correctedAddress!
              }
            }}
          />
        </WSElement>
      ) : null}

      {isOverride ? (
        <WSPanel>
          <WSFlexBox.CenterY mb="L" justify="space-between">
            <WSText.Paragraph weight="medium">
              Address correction
            </WSText.Paragraph>
            <WSPill type="dark" text="Overwritten by you" theme="violet" />
          </WSFlexBox.CenterY>
          <WSForm.Field
            mb="M"
            name="formW9Address.country"
            label="Country"
            component={WSSelect}
            componentProps={{
              internalSearch: true,
              options: COUNTRY_OPTIONS
            }}
          />
          <WSForm.Value name="formW9Address.country">
            {(country: string) => (
              <FormPartialAddress
                name="formW9Address"
                label={
                  taxFormViewer === TaxFormViewer.Payee
                    ? "Your business address"
                    : "Recipient's business address"
                }
                country={country || "US"}
              />
            )}
          </WSForm.Value>
        </WSPanel>
      ) : (
        <>
          <WSForm.Field
            mb="M"
            name="formW9Address.country"
            label="Country"
            component={WSSelect}
            componentProps={{
              internalSearch: true,
              options: COUNTRY_OPTIONS
            }}
          />
          <WSForm.Value name="formW9Address.country">
            {(country: string) => (
              <FormPartialAddress
                name="formW9Address"
                label={
                  taxFormViewer === TaxFormViewer.Payee
                    ? "Your business address"
                    : "Recipient's business address"
                }
                country={country || "US"}
              />
            )}
          </WSForm.Value>
        </>
      )}
    </WSPanel>
  );
};
